import { ICardPropertyElement } from '../../../components/CardProperties/types';

export const checkIfAllCardPropertiesAreDefault = (
    cardProperties: ICardPropertyElement[]
): boolean => {
    let isAllPropertiesAreDefault = true;
    for (let i = 0; i < cardProperties.length; i++) {
        if (!cardProperties[i].isDefault) {
            isAllPropertiesAreDefault = false;
        }

        if (!isAllPropertiesAreDefault) break;
    }
    return isAllPropertiesAreDefault;
}
